import { ACTIVITIES_FONT_K, ActivitiesFontSize } from 'global/constants';
import { getFontSizesFromBase } from './activity-builder-theme.utils';

export interface ActivityBuilderTheme {
  theming: {
    font: {
      medium: {
        size: ActivitiesFontSize;
        lineHeight: number;
      };
      small: {
        size: number;
        lineHeight: number;
      };
    };
  };
}

export const defaultTheme: ActivityBuilderTheme = {
  theming: {
    font: {
      ...getFontSizesFromBase(ACTIVITIES_FONT_K),
    },
  },
};
